import BaseObject from "./BaseObject.js";
export default class CommunicationCenterObject {
  static _objectDefinition() {
    return {
      location: "",
      event: "",
      startDate: null,
      endDate: null
    };
  }

  static _parseLocations(data) {
    let res = [];
    for (let tmp in data) {
      res.push({
        Name: data[tmp].Name,
        id: data[tmp].Id
      });
    }
    return res;
  }

  static _parseLocationEventsData(data) {
    let outputArray = [];

    if (!data.hasOwnProperty("EventDefs")) return outputArray;

    return BaseObject._createArrayWithObjects(data.EventDefs);
  }

  static _parseEventSavedMessagesData(data) {

    if (!data.hasOwnProperty("CommunicationUnits")) return [];

    return BaseObject._createArrayWithObjects(data.CommunicationUnits);
  }

  static _eventSavedMessagesRequestObject(
    eventId,
    startTime = null,
    endTime = null
  ) {
    let retObj = {
      EventId: eventId,
      Fields: {}
    };

    return retObj;
  }

  static _communicationCenterObject(object) {
    let startDate = new Date(object.startDate);
    console.log("startDate ", startDate);
    let startYear = startDate.getUTCFullYear();
    let startMonth = startDate.getUTCMonth();
    let startDay = startDate.getUTCDate();
    let startDateHour =
      Date.UTC(startYear, startMonth, startDay, 0, 0, 0, 0) / 1000;
    console.log("start time of day is : ", startDateHour);

    let endDate = new Date(object.endDate);
    console.log("endDate ", endDate);
    let endYear = endDate.getUTCFullYear();
    let endMonth = endDate.getUTCMonth();
    let endDay = endDate.getUTCDate();
    let endDateHour =
      Date.UTC(endYear, endMonth, endDay, 0, 0, 0, 0) / 1000 + 86400;
    console.log("end time of day is : ", endDateHour);

    let retObj = [];

    retObj.push({
      StartDate: startDateHour,
      EndDate: endDateHour,
      Destination: object.location,
      EventId: object.event
    });

    return retObj;
  }

  static _sendSingleMessageObject(object, userGroup, eventData) {


    if (object.ToEventSubscribers == null ) {
      object.ToEventSubscribers = 0;
    }

    let jsonString = {
      EventId: eventData.eventId,
      Title: object.Title,
      Text: object.Text,
      PromoCode: object.PromoCode,
      Tags: {
        [object.tags.group] : {
          [object.tags.id] : object.tags.name
        }
      },
      Picture: object.picture,
      ProductId: object.selectedProduct,
      ToEventSubscribers: object.ToEventSubscribers,
      UserGroup: userGroup
    };

    return jsonString;
  }
  static _saveSingleMessageForEngagementCampaignObject(object, userGroup, eventData, pack = true) {
    console.log("the time is ", object.time, object.time.charAt(0));

    console.log("_saveSingleMessageObject object", object);
    if (object.date == null) throw "Date parameter is missing";
    // if (object.time.length != 5) throw "Time parameter is missing";

    if (object.ToEventSubscribers == null ) {
      object.ToEventSubscribers = 0;
    }

    let dateTime =
      object.date
        .split("-")
        .reverse()
        .join("-") +
      " " +
      object.time;

    let jsonString = {
      EventId: eventData.eventId,
      UnitId: object.UnitId,
      Title: object.Title,
      Text: object.Text,
      PromoCode: object.PromoCode,
      DateTime: dateTime,
      Tags: {
        [object.tags.group] : {
          [object.tags.id] : object.tags.name
        }
      },
      Picture: object.picture,
      ProductId: object.selectedProduct,
      UserGroup: userGroup,
      ToEventSubscribers: object.ToEventSubscribers
    };

    return jsonString;
  }

  static _saveSingleMessageObject(object, userGroup, eventData, pack = true) {
    console.log("the time is ", object.time, object.time.charAt(0));
    if (object.time.length != 4 && object.time.charAt(2) !== ":" || object.time.charAt(0) > "2" || (object.time.charAt(0) == "2" && object.time.charAt(1) >= "4")) {
      window.EventBus.fire("inputDialog");
      return null;
    }

    if (
      object.time.charAt(2) == "6" ||
      object.time.charAt(2) == "7" ||
      object.time.charAt(2) == "8" ||
      object.time.charAt(2) == "9" ||
      object.time.length > 5
    ) {
      window.EventBus.fire("inputDialog");
      return null;
    }
    if (object.time.charAt(2) !== ":") {
      object.time = object.time.slice(0, 2) + ":" + object.time.slice(2, 4);
      console.log("the new time is ", object.time);
    }
    // if (object.time.length <= 2 && object.time.length > 3) {
    //   throw "Time input is not valid, please enter a valid time";
    // }
    // if (
    //   object.time.charAt(0) !== "0" &&
    //   object.time.charAt(0) !== "1" &&
    //   object.time.charAt(0) !== "2"
    // ) {
    //   throw "Time input is not correct, please check choose a valid time";
    // }
    // if (object.time.charAt(2) !== ":") {
    //   object.time = object.time.slice(0, 2) + ":" + object.time.slice(2, 4);
    // }
    // if (
    //   object.time.charAt(3) == "6" ||
    //   object.time.charAt(3) == "7" ||
    //   object.time.charAt(3) == "8" ||
    //   object.time(charAt(3) == "9")
    // ) {
    //   throw "Time input is not correct, please check choose a valid time";
    // }
    console.log("_saveSingleMessageObject object", object);
    if (object.date == null) throw "Date parameter is missing";
    // if (object.time.length != 5) throw "Time parameter is missing";

    let dateTime =
      object.date
        .split("-")
        .reverse()
        .join("-") +
      " " +
      object.time;


    if (object.ToEventSubscribers == null ) {
      object.ToEventSubscribers = 0;
    }


    let jsonString = {
      EventId: eventData.eventId,
      UnitId: object.UnitId,
      Title: object.Title,
      Text: object.Text,
      PromoCode: object.PromoCode,
      DateTime: dateTime,
      ToEventSubscribers: object.ToEventSubscribers,
      Tags: {
        [object.tags.group] : {
          [object.tags.id] : object.tags.name
        }
      },
      Picture: object.picture,
      ProductId: object.selectedProduct,
      UserGroup: userGroup
    };

    return jsonString;
  }
  static _deleteRequestObject(UnitId) {
    let reqObj = {
      UnitId: UnitId
    };

    return reqObj;
  }
}
